import axios from 'axios';

class UserService {
  constructor() {
    this.currentUser = null;
    this.listeners = [];
  }

  async fetchCurrentUser() {
    try {
      const response = await axios.get('/api/token/');
      if (response.data && response.data.username) {
        this.currentUser = {
          id: response.data.user_id,
          username: response.data.username,
          first_name: response.data.first_name,
          last_name: response.data.last_name,
          token: response.data.token,
          is_staff: response.data.is_staff
        };
        this.notifyListeners();
        return this.currentUser;
      }
      return null;
    } catch (error) {
      console.error('Error fetching current user:', error);
      return null;
    }
  }

  getCurrentUser() {
    return this.currentUser;
  }

  setCurrentUser(user) {
    this.currentUser = user;
    this.notifyListeners();
  }

  clear() {
    this.currentUser = null;
    this.notifyListeners();
  }

  addListener(callback) {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter(listener => listener !== callback);
    };
  }

  notifyListeners() {
    this.listeners.forEach(callback => callback(this.currentUser));
  }

  async initialize() {
    const token = localStorage.getItem('token');
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Token ${token}`;
      return await this.fetchCurrentUser();
    }
    return null;
  }
}

const userService = new UserService();
export default userService;
